import BabyUITheme from 'baby-ui/lib/BabyUITheme'
import BabyUIPaletteColorNode from 'baby-ui/lib/BabyUIPaletteColorNode'
import { TypeBackground } from '@material-ui/core/styles/createPalette'

export default class GetYourPumpThroughInsuranceTheme extends BabyUITheme {
  protected htmlBaseFontSize = 16

  readonly buttonRadius: number = 0

  private readonly PRIMARY_COLOR = '#6F3365'

  private readonly SECONDARY_MAIN_COLOR = '#007994'

  private readonly SECONDARY_DARK_COLOR = '#076175'

  private readonly DEFAULT_BG_COLOR = '#FFFFFF'

  protected getBackgroundColor(): Partial<TypeBackground> {
    return { default: this.DEFAULT_BG_COLOR }
  }

  protected getHTMLFontSize(): number {
    return this.htmlBaseFontSize
  }

  protected getPrimaryColor(): BabyUIPaletteColorNode {
    return new BabyUIPaletteColorNode(this.PRIMARY_COLOR)
  }

  protected getSecondaryColor(): BabyUIPaletteColorNode {
    return new BabyUIPaletteColorNode(this.SECONDARY_MAIN_COLOR, {
      dark: this.SECONDARY_DARK_COLOR,
    })
  }
}
